import httpClient from './http-clients/portaljad'

const baseUrl = 'etiqueta'

export default class EtiquetaService {
  static async enviaEtiquetaTeste(etiqueta) {
    const { data } = await httpClient.post(`${baseUrl}/teste-dados-api`, etiqueta)
    return data
  }
}